import { ObjectHelper } from 'Code/Helpers/ObjectHelper';

export class ToLocaleDateTimeBaseValueConverter {
    toView(value) {
        if (ObjectHelper.IsNotNullAndUndefined(value)) {
            return moment(value).format('l').replaceAll(" ", "") + ' ' + moment(value).format('LT');
        }
        return value;
    }
}